<div style="width: calc(720px + 1rem);"></div>
<h4>
  {{ selectedLottery.event.date.date | date: 'dd.MM.yyyy' }}
  {{ selectedLottery.event.getFormattedEventName() }}
</h4>
<label class="esf-form-item__label">
  <div class="esf-form-item__label-sub" i18n="@@lotteryExecution.subHeading.executionSuccessful">
    The lottery was executed successfully. The status of the drawn requrests was changed.
    You can now start creating reservations via Tixx.
  </div>
</label>

<div class="esf-info-tile esf-info-tile--static summary-margin">
  <div class="esf-info-tile__content">
    <div class="esf-execution__info--no-table">
      <div>
        <div>
          <div class="icon-and-text">
            <span class="esf-icon--info large-text">{{ executionResults.numberOfWinners }}</span>
            <svg class="esf-icon esf-icon--info icon-margin" width="32" height="32">
              <use xlink:href="#esf-icon-user-48"></use>
            </svg>
          </div>
          <h5 class="esf-icon--info"
              i18n="@@lotteryExecution.summaryTitle.winners">{ executionResults.numberOfWinners, plural, =1 { Winner } other { Winners }}</h5>
        </div>
      </div>
      <div>
        <div>
          <div class="icon-and-text">
            <span class="large-text">{{ executionResults.numberOfDrawnTickets }}</span>
            <svg class="esf-icon icon-margin" width="32" height="32">
              <use xlink:href="#esf-icon-ticket-48"></use>
            </svg>
          </div>
          <h5 i18n="@@lotteryExecution.summaryTitle.tickets">{ executionResults.numberOfDrawnTickets, plural, =1 { Ticket } other { Tickets }}</h5>
        </div>
      </div>
      <div>
        <div class="icon-and-text">
          <span class="esf-icon--success large-text">{{ executionResults.priceCategoryCapacity }}</span>
          <svg class="esf-icon esf-icon--success icon-margin" width="32" height="32">
            <use xlink:href="#esf-icon-sofa-48"></use>
          </svg>
        </div>
        <h5 class="esf-icon--success"
            i18n="@@lotteryExecution.summaryTitle.freeSeats">{ executionResults.priceCategoryCapacity, plural, =1 { Free seat } other { Free seats }}</h5>
      </div>
    </div>
  </div>
</div>

<div style="display: flex; justify-content: flex-end; margin-right: 1rem; margin-top: 2rem;">
  <app-submit-row-buttons style="max-width: calc(720px + 2rem);"
                          [showCancel]="false"
                          (submitButton)="createReservations()"
                          [spinnerName]="spinnerName"
                          [submitButtonText]="buttonsTranslations.i18nCreateReservations">
  </app-submit-row-buttons>
</div>
